import React from 'react';
import PropTypes from 'prop-types';

export const Refresh = ({ width, height, ...props }) => (
  <svg
    data-icon='refresh'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12.05 20c-2.233 0-4.133-.775-5.7-2.325C4.783 16.125 4 14.233 4 12v-.175l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6V12c0 1.667.588 3.083 1.763 4.25C8.938 17.417 10.367 18 12.05 18c.433 0 .858-.05 1.275-.15.417-.1.825-.25 1.225-.45l1.5 1.5a8.247 8.247 0 0 1-1.95.825 7.698 7.698 0 0 1-2.05.275ZM19 15.975l-4-4 1.4-1.4 1.6 1.6V12c0-1.667-.587-3.083-1.762-4.25C15.063 6.583 13.633 6 11.95 6c-.433 0-.858.05-1.275.15-.417.1-.825.25-1.225.45l-1.5-1.5a8.25 8.25 0 0 1 1.95-.825A7.696 7.696 0 0 1 11.95 4c2.233 0 4.133.775 5.7 2.325C19.217 7.875 20 9.767 20 12v.175l1.6-1.6 1.4 1.4-4 4Z'
    />
  </svg>

);

Refresh.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Refresh.defaultProps = {
  width: 24,
  height: 24,
};
